import {initInputCount} from '../common/form';

const MODAL_SELECTOR = '#ai-text-prompt-test-modal';
const RESULT_SUCCESS_CLASS = 'ai-text-prompt-test-modal__result_success';
const RESULT_ERROR_CLASS = 'ai-text-prompt-test-modal__result_error';

let activeFieldUuid = null;

function getModal() {
  return document.querySelector(MODAL_SELECTOR);
}

function getActivePromptTextarea() {
  if (!activeFieldUuid) {
    return null;
  }

  return document.querySelector(
    `.custom_field_block[data-custom-field-uuid="${activeFieldUuid}"] textarea.ai-text-field-prompt`
  );
}

function resetResult(modal) {
  const resultBlock = modal.querySelector('.ai-text-prompt-test-modal__result');
  const checkBtn = modal.querySelector('.ai-text-prompt-test-modal__check-btn');
  const closeBtn = modal.querySelector('.ai-text-prompt-test-modal__close-btn');
  const sampleTextarea = modal.querySelector('#ai-text-prompt-test-sample');

  resultBlock.hidden = true;
  resultBlock.classList.remove(RESULT_SUCCESS_CLASS, RESULT_ERROR_CLASS);
  resultBlock.innerHTML = '';
  checkBtn.hidden = false;
  checkBtn.disabled = false;
  checkBtn.textContent = 'Проверить';
  closeBtn.hidden = true;
  sampleTextarea.value = '';
  sampleTextarea.disabled = false;

  const helperCurrent = modal.querySelector('.ai-text-prompt-test-modal__counter .js-input-count-helper-current');
  if (helperCurrent) {
    helperCurrent.textContent = '0';
  }
}

function openModal(fieldUuid) {
  const modal = getModal();

  if (!modal) {
    return;
  }

  activeFieldUuid = fieldUuid;
  resetResult(modal);
  modal.hidden = false;
  document.body.classList.add('ai-text-prompt-test-modal-open');
  modal.querySelector('#ai-text-prompt-test-sample')?.focus();
}

function closeModal() {
  const modal = getModal();

  if (!modal) {
    return;
  }

  modal.hidden = true;
  document.body.classList.remove('ai-text-prompt-test-modal-open');
  activeFieldUuid = null;
}

function renderViolations(violations) {
  const items = violations.map((violation) => {
    const tag = violation.tag || 'Нарушение';
    const reason = violation.reason || '';

    return `
      <div class="ai-text-prompt-test-modal__violation">
        <span class="ai-text-prompt-test-modal__violation-tag">${escapeHtml(tag)}</span>
        ${reason ? `<div class="ai-text-prompt-test-modal__violation-reason">${escapeHtml(reason)}</div>` : ''}
      </div>
    `;
  }).join('');

  return `<div class="ai-text-prompt-test-modal__violations">${items}</div>`;
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function showResult(modal, result) {
  const resultBlock = modal.querySelector('.ai-text-prompt-test-modal__result');
  const checkBtn = modal.querySelector('.ai-text-prompt-test-modal__check-btn');
  const closeBtn = modal.querySelector('.ai-text-prompt-test-modal__close-btn');
  const sampleTextarea = modal.querySelector('#ai-text-prompt-test-sample');

  resultBlock.hidden = false;
  checkBtn.hidden = true;
  closeBtn.hidden = false;
  sampleTextarea.disabled = true;

  if (result.passed) {
    resultBlock.classList.add(RESULT_SUCCESS_CLASS);
    resultBlock.innerHTML = `
      <div class="ai-text-prompt-test-modal__result-title">
        <span class="ai-text-prompt-test-modal__result-icon" aria-hidden="true">✓</span>
        Проверка пройдена, нарушений не найдено
      </div>
    `;
    return;
  }

  const violationsCount = result.violations?.length || 0;
  resultBlock.classList.add(RESULT_ERROR_CLASS);
  resultBlock.innerHTML = `
    <div class="ai-text-prompt-test-modal__result-title">
      <span class="ai-text-prompt-test-modal__result-icon" aria-hidden="true">!</span>
      Такая заявка была бы заблокирована: ${violationsCount} ${pluralizeViolations(violationsCount)}
    </div>
    ${renderViolations(result.violations || [])}
  `;
}

function pluralizeViolations(count) {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return 'нарушение';
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return 'нарушения';
  }

  return 'нарушений';
}

function showError(modal, message) {
  const resultBlock = modal.querySelector('.ai-text-prompt-test-modal__result');
  const checkBtn = modal.querySelector('.ai-text-prompt-test-modal__check-btn');

  resultBlock.hidden = false;
  resultBlock.classList.add(RESULT_ERROR_CLASS);
  resultBlock.innerHTML = `<div class="ai-text-prompt-test-modal__result-title">${escapeHtml(message)}</div>`;
  checkBtn.disabled = false;
  checkBtn.textContent = 'Проверить';
}

async function runCheck(modal) {
  const promptTextarea = getActivePromptTextarea();
  const sampleTextarea = modal.querySelector('#ai-text-prompt-test-sample');
  const checkBtn = modal.querySelector('.ai-text-prompt-test-modal__check-btn');
  const testUrl = modal.getAttribute('data-test-url');

  if (!promptTextarea || !sampleTextarea || !testUrl) {
    showError(modal, 'Не удалось подготовить проверку.');
    return;
  }

  checkBtn.disabled = true;
  checkBtn.textContent = 'Проверяем...';

  const formData = new FormData();
  formData.append('ai_prompt', promptTextarea.value);
  formData.append('sample_text', sampleTextarea.value);

  try {
    const response = await fetch(testUrl, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    });
    const data = await response.json();

    if (data.status !== 'success' || !data.result) {
      const message = data.messages?.[0]?.message || 'Не удалось выполнить проверку.';
      showError(modal, message);
      return;
    }

    showResult(modal, data.result);
  } catch (error) {
    showError(modal, 'Не удалось выполнить проверку. Попробуйте позже.');
  }
}

function bindModalEvents(modal) {
  modal.addEventListener('click', (event) => {
    const closeTrigger = event.target.closest('[data-ai-text-prompt-test-close]');

    if (closeTrigger) {
      closeModal();
    }
  });

  modal.querySelector('.ai-text-prompt-test-modal__check-btn')?.addEventListener('click', () => {
    runCheck(modal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
}

function bindOpenButtons(root = document) {
  root.querySelectorAll('.ai-text-prompt-test-open').forEach((button) => {
    if (button.dataset.aiTextPromptTestBound === '1') {
      return;
    }

    button.dataset.aiTextPromptTestBound = '1';
    button.addEventListener('click', () => {
      openModal(button.getAttribute('data-custom-field-uuid'));
    });
  });
}

export function initAiTextFieldPromptTest(root = document) {
  const modal = getModal();

  if (!modal || modal.dataset.initialized === '1') {
    bindOpenButtons(root);
    return;
  }

  modal.dataset.initialized = '1';
  bindModalEvents(modal);
  bindOpenButtons(root);
  initInputCount();
}

export default initAiTextFieldPromptTest;
